import React, { useState } from "react";
import { Grid, makeStyles, Tooltip, Typography } from "@material-ui/core";
import { ContentCopyIcon } from "@bonliva-crm/ui";
import locale from "@bonliva-crm/locale";

export type QualityItemMetaProps = {
  title: string;
  description?: React.ReactNode;
  canCopy?: boolean;
};

const copyToClipboard = (text?: string | null) => {
  if (text) navigator.clipboard.writeText(text);
  return;
};

export function QualityCheckMeta({
  title,
  description,
  canCopy: _canCopy
}: QualityItemMetaProps) {
  const classes = useStyles();
  const [copied, setCopied] = useState(false);
  const hasDescription = Boolean(description);

  const canCopy = _canCopy && typeof description === "string";

  const copyIcon = canCopy ? (
    <ContentCopyIcon
      className={classes.contentCopy}
      style={{ display: "inline" }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        copyToClipboard(description);
        setCopied(true);
        setTimeout(() => setCopied(false), 500);
      }}
    />
  ) : undefined;

  const desc = hasDescription ? (
    <>
      <Typography variant="caption">{description}</Typography>
      {copyIcon}
    </>
  ) : null;

  return (
    <Grid container spacing={0} wrap={"nowrap"} alignItems={"center"}>
      <Grid item xs="auto">
        <Typography variant="caption" style={{ fontWeight: 500, whiteSpace: "nowrap" }}>
          {title}
          {hasDescription ? ":" : ""}
        </Typography>
      </Grid>

      {hasDescription && (
        <Grid item xs={12} style={{ marginLeft: "4px" }}>
          {canCopy ? (
            <Tooltip
              title={copied ? locale.Copied : locale.CopyToClipboard}
              placement="bottom"
            >
              <div className={classes.valueWrapper}>{desc}</div>
            </Tooltip>
          ) : (
            desc
          )}
        </Grid>
      )}
    </Grid>
  );
}

const useStyles = makeStyles((theme) => ({
  contentCopy: {
    width: "16px",
    height: "16px",
    cursor: "pointer",
    verticalAlign: "text-top",
    marginLeft: "4px"
  },
  valueWrapper: {
    position: "relative",
    display: "inline",
    flexDirection: "row",
    maxWidth: "100%"
  }
}));
